export default function valueOrEmpty(value) {
  return value ? value : ''
}
